import { FC } from "react";
import { useTranslation } from "react-i18next";

import H3 from "../Components/forms/H3";
import { cn } from "../Components/helpers";

/**
 * Privacy Policy + Terms of Service, rendered from i18n content blocks
 * (PrivacyPolicy:blocks) so it follows the selected language. English is the
 * authoritative source; the Swedish translation is a machine-produced DRAFT and
 * MUST be reviewed by legal before go-live — hence the draft banner shown in sv.
 */
type Block = { h?: string; p?: string };

const PrivacyPolicyView: FC<{ openInDialog?: boolean }> = ({ openInDialog }) => {
  const { t, i18n } = useTranslation(["common", "PrivacyPolicy"]);

  const blocks =
    (t("PrivacyPolicy:blocks", { returnObjects: true }) as unknown as Block[]) ||
    [];
  const showDraftNotice = (i18n.language || "").toLowerCase().startsWith("sv");

  return (
    <div className="flex flex-col items-center justify-center w-full my-24">
      <H3 text={t("common:privacyPolicy")} />
      <div className={cn("mx-10 mt-5", { "xl:w-6/12": !openInDialog })}>
        {showDraftNotice && (
          <p
            style={{
              border: "1px solid #e0a800",
              background: "#fff8e1",
              color: "#5c4a00",
              borderRadius: 8,
              padding: "12px 16px",
              marginBottom: 24,
              fontSize: 14,
              lineHeight: 1.5,
            }}
          >
            {t("PrivacyPolicy:draftNotice")}
          </p>
        )}
        {Array.isArray(blocks) &&
          blocks.map((block, i) =>
            block.h ? (
              <p key={i} className="mt-6 mb-2 font-bold">
                {block.h}
              </p>
            ) : (
              <p key={i} className="mb-3 leading-6">
                {block.p}
              </p>
            ),
          )}
      </div>
    </div>
  );
};

export default PrivacyPolicyView;
